var _g, _rect, _path, _path2, _path3, _rect2, _rect3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNodata(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 177,
    viewBox: "0 0 270 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_14)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 135,
    cy: 153.611,
    rx: 132,
    ry: 20,
    fill: "#F5A6C6",
    fillOpacity: 0.22
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 79.6106,
    width: 186,
    height: 75,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 79.1106H226C226.828 79.1106 227.5 79.7821 227.5 80.6106V149.611C227.5 152.096 225.485 154.111 223 154.111H47C44.5147 154.111 42.5 152.096 42.5 149.611V80.6106C42.5 79.7821 43.1716 79.1106 44 79.1106Z",
    fill: "#E72B78",
    fillOpacity: 0.13,
    stroke: "#E72B78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5 36.0845L76.5 79.1105L43.5134 79.1106L76.5 36.0845ZM193.502 36.0871L226.487 79.1191L193.554 79.1191L193.502 36.0871Z",
    fill: "#E72B78",
    fillOpacity: 0.59,
    stroke: "#E72B78"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78 35.1106H192C192.828 35.1106 193.5 35.7822 193.5 36.6106V79.1106H76.5V36.6106C76.5 35.7822 77.1716 35.1106 78 35.1106Z",
    fill: "#E72B78",
    fillOpacity: 0.42,
    stroke: "#E72B78"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 97.5,
    y: 88.1106,
    width: 75,
    height: 12,
    rx: 6,
    fill: "#F5A6C6",
    stroke: "#E72B78"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 106.5,
    y: 41.1106,
    width: 57,
    height: 9,
    rx: 4.5,
    fill: "white",
    stroke: "#E72B78"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_14",
    x: 0,
    y: 130.611,
    width: 270,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_1_14"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodata);
export default __webpack_public_path__ + "static/media/nodata.7242774af1393f05b520527581ad896e.svg";
export { ForwardRef as ReactComponent };